import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  card: {
    '&&': {
      width: '100%',
      padding: 0,
      overflow: 'visible',
      border: `1px solid ${theme.colors.card_divider}`,
      background: theme.colorPalette.white
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    padding: theme.spacing(4),
    borderBottom: `1px solid ${theme.colors.card_divider}`
  },
  heading: { '&&': { margin: 0, fontSize: 16, fontWeight: 600 } },
  body: { padding: theme.spacing(4) },
  intro: { margin: theme.spacing(0, 0, 4), color: theme.colors.text_secondary },
  product: { marginBottom: theme.spacing(4), minWidth: 0 },
  productTitle: { '&&': { fontSize: 15, fontWeight: 600, margin: theme.spacing(0, 0, 2) } },
  forms: {
    minWidth: 0,
    '& > div': { maxWidth: '100%', marginTop: 0 },
    '& [data-card]': { boxShadow: 'none', borderWidth: 1, borderColor: theme.colors.card_divider },
    '& > div > [data-section-header]': { marginTop: 0 },
    '& [data-section-header]': { paddingTop: theme.spacing(2) },
    '& [data-section-header] [data-cy="section-title"]': { fontSize: 15, lineHeight: '22px', fontWeight: 600 }
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
    '& > div': { flex: '1 1 100%' }
  },
  review: { display: 'flex', flexDirection: 'column', gap: theme.spacing(3) },
  disclosure: {
    padding: theme.spacing(4),
    border: `1px solid ${theme.colors.card_divider}`,
    borderRadius: theme.sizes.roundCorners,
    background: theme.colorPalette.white,
    '& > summary': { cursor: 'pointer', fontWeight: 600 },
    '&[open] > summary': { marginBottom: theme.spacing(4) }
  }
}));
